<template>
  <div>
    <Multiselect
      class="multiselect-custom-input campaign-selector"
      v-model="value"
      :close-on-select="true"
      :searchable="false"
      :options="options"
      :loading="loading"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      this.$emit('onChange', this.value);
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.loading = true;
      this.$api
        .get('api/campaign/all')
        .then((res) => {
          this.loading = false;
          this.options = res.data.map((b) => {
            return { value: b.id, label: b.name };
          });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
.campaign-selector {
  border: 1px solid #e2e5e8 !important;
  border-radius: 0.75rem !important;
}
</style>
